export default __webpack_public_path__ + "static/media/07_3_TandM.0dabb505.png";